import {signal} from '@angular/core';
import {UserGroupsData, UserGroupsQueryBuilder, UserGroupsSortType} from '@data-users';
import {Cached} from '@utils';
import {GlobalSearchCategory, GlobalSearchFilterType, IFilterUpdateResult} from '../types/global-search.types';
import {FilterDefinition, GlobalSearchAbstractCategory} from './global-search-category-config.abstract';

export class UserGroupCategory extends GlobalSearchAbstractCategory<UserGroupsQueryBuilder> {
	public category: GlobalSearchCategory = GlobalSearchCategory.USER_GROUP;

	public static readonly UserGroupHelperData = UserGroupsData.getQueryUserGroupsData();
	private groupHelperData = UserGroupCategory.UserGroupHelperData;

	/* ---------------------- Sorting ---------------------- */
	public static readonly UserGroupSortOptions = this.UserGroupHelperData.Sorting.markers;
	public readonly sortOptions = Object.values(this.groupHelperData.Sorting.markers);

	/* ---------------------- Filters ---------------------- */
	private readonly GroupName = new FilterDefinition<UserGroupsQueryBuilder, string>({
		type: GlobalSearchFilterType.GroupName,
		labelKey: this.groupHelperData.Sorting.markers[UserGroupsSortType.Name].label,
		icon: this.groupHelperData.Sorting.markers[UserGroupsSortType.Name].icon,
		controlType: 'text',
		onValueChanged: (value: string | null): IFilterUpdateResult<string> => {
			// נרמול של ערך טקסט - להסיר רווחים מיותרים ולבדוק שיש תוכן
			const normalizedValue = value?.trim() || undefined;

			return {
				normalizedValue,
				requiresSearch: true,
			};
		},
		placeholder: 'filters.userGroup.groupNamePlaceholder',
		applyFilter: (builder: UserGroupsQueryBuilder, value: string): void => {
			if (value) {
				builder.setSearch(value);
			}
		},
		controlOptions: {
			styleClass: 'filter-control',
		},
	});
	private readonly MemberCount = new FilterDefinition<UserGroupsQueryBuilder, string>({
		type: GlobalSearchFilterType.MemberCount,
		labelKey: this.groupHelperData.Sorting.markers[UserGroupsSortType.UsersCount].label,
		icon: this.groupHelperData.Sorting.markers[UserGroupsSortType.UsersCount].icon,
		controlType: 'select',
		options: signal([
			{value: '1-10', label: '1-10'},
			{value: '11-50', label: '11-50'},
			{value: '51-100', label: '51-100'},
		]),
		onValueChanged: (value: string | null): IFilterUpdateResult<string> => {
			return {
				normalizedValue: value || undefined,
				requiresSearch: true,
			};
		},
		applyFilter: (builder: UserGroupsQueryBuilder, value: string): void => {
			if (value) {
				const [min, max] = value.split('-').map(v => parseInt(v, 10));
				// builder.se(min, max);
			}
		},
	});
	private readonly LockedStatus = new FilterDefinition<UserGroupsQueryBuilder, boolean>({
		type: GlobalSearchFilterType.LockedStatus,
		labelKey: this.groupHelperData.Filters.toggleLockedGroups.label,
		icon: this.groupHelperData.Filters.toggleLockedGroups.icon,
		controlType: 'checkbox',
		onValueChanged: (value: boolean | null): IFilterUpdateResult<boolean> => {
			return {
				normalizedValue: value === true ? true : undefined,
				requiresSearch: true,
			};
		},
		applyFilter: (builder: UserGroupsQueryBuilder, value: boolean): void => {
			if (value === true) {
				// builder.setLockedStatus(true);
			}
		},
	});
	private readonly EnabledStatus = new FilterDefinition<UserGroupsQueryBuilder, string>({
		type: GlobalSearchFilterType.EnabledStatus,
		labelKey: 'filters.userGroup.enabledStatus',
		placeholder: 'filters.enabledStatusPlaceholder',
		icon: 'fa-duotone fa-toggle-on',
		controlType: 'select',
		options: signal([
			{value: 'true', label: 'פעילות בלבד'},
			{value: 'false', label: 'לא פעילות בלבד'},
		]),
		onValueChanged: (value: string | null): IFilterUpdateResult<string> => {
			return {
				normalizedValue: value || undefined,
				requiresSearch: true,
			};
		},
		applyFilter: (builder: UserGroupsQueryBuilder, value: string): void => {
			if (value) {
				// builder.setEnabledStatus(value === 'true');
			}
		},
	});

	@Cached()
	getFilters(): FilterDefinition<UserGroupsQueryBuilder, any>[] {
		return [this.GroupName, this.MemberCount, this.LockedStatus, this.EnabledStatus];
	}
}
